"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardTypeArray = exports.CardTypeEnum = void 0;
var CardTypeEnum;
(function (CardTypeEnum) {
    CardTypeEnum["VIRTUAL"] = "VIRTUAL";
    CardTypeEnum["PHYSICAL"] = "PHYSICAL";
})(CardTypeEnum || (exports.CardTypeEnum = CardTypeEnum = {}));
exports.cardTypeArray = Object.values(CardTypeEnum);
